// A number input changes its value when the wheel (a two-finger scroll on a
// trackpad) moves over it while it has the focus: a cut length or a Max
// breedte typed a moment ago is nudged without anyone typing. Browsers
// register wheel listeners as passive, so the event cannot be cancelled;
// the input is blurred instead, which stops the browser stepping it and
// lets the page scroll as the gesture meant to.

export const isNumberInput = (element) =>
    !!element && element.tagName === 'INPUT' && String(element.type).toLowerCase() === 'number';

/** The wheel handler: blurs the focused number input the wheel is over, leaves everything else alone. */
export const guardNumberWheel = (event, doc) => {
    const target = event && event.target;
    if (!isNumberInput(target)) return false;
    const active = doc ? doc.activeElement : (typeof document !== 'undefined' ? document.activeElement : null);
    if (active !== target) return false;
    target.blur();
    return true;
};

/** Installs the guard once on the document (capture, passive); returns the uninstaller. */
export const installNumberWheelGuard = (doc = typeof document !== 'undefined' ? document : null) => {
    if (!doc || typeof doc.addEventListener !== 'function') return () => { };
    const handler = (event) => guardNumberWheel(event, doc);
    doc.addEventListener('wheel', handler, { capture: true, passive: true });
    return () => doc.removeEventListener('wheel', handler, { capture: true });
};
